import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState } from "react";
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { updateCaseDataOfContact } from '../../Utility/UpdateCaseData/UpdateCaseData';
import { loginTimeOutAndRedirectHandler } from '../../Utility/LoginTimeOutAndRedirectHandler/LoginTimeOutAndRedirectHandler';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import { setAllDataOfContact } from '../../Redux/Index';
import { useDispatch } from 'react-redux';

// Redux func start

const mapStateToPropsForAllData = state => {
  return {
    allDataOfContact: state.allDataOfUser.allDataOfContact
  }
}

// Redux func end

function CaseDetail({ allDataOfContact }) {

  // sessionStorage.setItem("Pdsk21D34Rl98", false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const originalId = id.substring(9, id.length - 4);

  const [isDataSubmitting, setIsDataSubmitting] = useState(false);
  const [originError, setOriginError] = useState(false);
  const [statusError, setStatusError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [caseData, setCaseData] = useState({
    Id: originalId
  });

  useEffect(() => {

    if((allDataOfContact) && (allDataOfContact.success)) {
      setIsLoading(false);
    }

    if(Object.keys(caseData).length === 1) {
      if(allDataOfContact.data && allDataOfContact.data.Cases) {
        allDataOfContact.data.Cases.records.forEach((rowData) => {
          if(rowData.Id == originalId) {
            setCaseData(rowData);
            return;
          }
        });
      }
  
    } 
    
  }, [allDataOfContact, isLoading, caseData]);


  // Input field value handler start

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setCaseData({
      ...caseData,
      [name]: value,
    });
  };

  // Input field value handler end

  // Input field error handler start

  const statusFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Status" && value=="--None--") {
      setStatusError(true);
    } else {
      setStatusError(false);
    }
  }

  const originFieldErrorHandler = (e) => {
    const { name, value } = e.target;
    if(name=="Origin" && value=="--None--") {
      setOriginError(true);
    } else {
        setOriginError(false);
    }
  }

  // Input field error handler end

  // Case submit func start

  function submitCaseData() {
    loginTimeOutAndRedirectHandler(updateCaseDataOfContact, caseData, dispatch, setAllDataOfContact, navigate, "/", "Case detail updated!", setIsDataSubmitting, "/Cases");
  }

  // Case submit func start

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1, textAlign: 'center', marginLeft: 2, marginBottom: 2, fontWeight: 'bold' }}
            >
              Case Detail
            </Typography>
        <CssBaseline />
        { Object.keys(caseData).length === 1 ?  <Box sx={{ display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center', marginTop: '20px'  }}><CircularProgress /></Box> : <Box
          sx={{
            marginTop: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6}>
            <InputLabel htmlFor="status" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Status</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                required
                id="status"
                value={(caseData.Status == "--None--" || caseData.Status == null) ? "--None--" : caseData.Status}
                name="Status"
                placeholder="Select Status"
                onChange={(e) => { statusFieldErrorHandler(e);handleInputChange(e); }}
                style={{ textAlign: "left" }}
                error={statusError}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"New"}>New</MenuItem>
                <MenuItem value={"Working"}>Working</MenuItem>
                <MenuItem value={"Escalated"}>Escalated</MenuItem>
              </Select>
              <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ statusError ? ' Status is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="priority" style={{ textAlign: "left", marginBottom: "1rem" }}>Priority</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="priority"
                value={(caseData.Priority == "--None--" || caseData.Priority == null) ? "--None--" : caseData.Priority}
                name="Priority"
                placeholder="Select Priority"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"High"}>High</MenuItem>
                <MenuItem value={"Medium"}>Medium</MenuItem>
                <MenuItem value={"Low"}>Low</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="origin" style={{ textAlign: "left", marginBottom: "1rem" }}><span style={{ color: 'red' }}>*</span> Case Origin</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                required
                id="origin"
                value={(caseData.Origin == "--None--" || caseData.Origin == null) ? "--None--" : caseData.Origin}
                name="Origin"
                placeholder="Select Origin"
                onChange={(e) => { originFieldErrorHandler(e);handleInputChange(e); }}
                style={{ textAlign: "left" }}
                error={originError}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Phone"}>Phone</MenuItem>
                <MenuItem value={"Email"}>Email</MenuItem>
                <MenuItem value={"Web"}>Web</MenuItem>
              </Select>
              <FormHelperText style={{ marginLeft: "10px", color: "#DA2F2F" }}>{ originError ? ' Origin is required!' : '' }</FormHelperText>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="type" style={{ textAlign: "left", marginBottom: "1rem" }}>Type</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="type"
                value={(caseData.Type == "--None--" || caseData.Type == null) ? "--None--" : caseData.Type}
                name="Type"
                placeholder="Select Type"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Mechanical"}>Mechanical</MenuItem>
                <MenuItem value={"Electrical"}>Electrical</MenuItem>
                <MenuItem value={"Electronic"}>Electronic</MenuItem>
                <MenuItem value={"Structural"}>Structural</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="reason" style={{ textAlign: "left", marginBottom: "1rem" }}>Case Reason</InputLabel>
                <Select
                margin="normal"
                fullWidth
                type="select"
                id="reason"
                value={(caseData.Reason == "--None--" || caseData.Reason == null) ? "--None--" : caseData.Reason}
                name="Reason"
                placeholder="Select Reason"
                onChange={handleInputChange}
                style={{ textAlign: "left" }}
              >
                <MenuItem value={"--None--"}>--None--</MenuItem>
                <MenuItem value={"Installation"}>Installation</MenuItem>
                <MenuItem value={"Equipment Complexity"}>Equipment Complexity</MenuItem>
                <MenuItem value={"Performance"}>Performance</MenuItem>
                <MenuItem value={"Breakdown"}>Breakdown</MenuItem>
                <MenuItem value={"Equipment Design"}>Equipment Design</MenuItem>
                <MenuItem value={"Feedback"}>Feedback</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="subject" style={{ textAlign: "left" }}>Subject</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              type="text"
              id="subject"
              name="Subject"
              value={caseData.Subject == null ? "" : caseData.Subject}
              placeholder="Enter Subject"
              onChange={handleInputChange}
            />
            </Grid>
            <Grid item xs={12} md={6}>
            <InputLabel htmlFor="description" style={{ textAlign: "left" }}>Description</InputLabel>
            <TextField
              margin="normal"
              fullWidth
              id="description"
              name="Description"
              value={caseData.Description == null ? "" : caseData.Description}
              placeholder="Enter Description Here"
              onChange={handleInputChange}
              multiline
              rows={2}
              maxRows={4}
            />
            </Grid>
            <Grid item xs={2} md={6} lg={8}>
            
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={() => { setIsDataSubmitting(true);submitCaseData() }}
              disabled={ (caseData.Status == "--None--" || caseData.Origin == "--None--") ? true : false }
            >
              { isDataSubmitting ? <CircularProgress size={24} style={{ color: "white" }} /> : "Update" }
            </Button>
            </Grid>
            <Grid item xs={5} md={3} lg={2}>
            <Link to="/Cases" style={{ textDecoration: 'none', color: 'transparent' }}>
            <Button
              type="submit"
              fullWidth
              variant="outlined"
              sx={{ mt: 3, mb: 2 }}
            >
              Cancel
            </Button>
            </Link>
            </Grid>
          </Grid>
        </Box> }
        


          </Container>
  )
}

export default connect(mapStateToPropsForAllData)(CaseDetail);